import { IconAttributeJourney } from '@components/icons/attribute-journey';
import { RelativeSpinner } from '@components/loading-spinner';
import { Sidebar, hideSidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { createJourneyActionFieldPath } from 'api/documents/requests';
import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ActionHeader, SidebarProps } from 'ui/journey-builder/node-types/common';

import { UpdateFieldsFormContent } from './helpers';

type ActionType = 'update_fields';

export const SidebarContent = (props: SidebarProps) => {
  const { t } = useScopedTranslate(sidebarLocale);
  const { journeyActionId } = props;
  const { data, isLoading } = useJourneyAction<ActionType>(journeyActionId);
  const editMutation = useUpdateJourneyAction(journeyActionId);

  if (isLoading || !data) {
    return <RelativeSpinner />;
  }
  const filePath = createJourneyActionFieldPath(data.journey, journeyActionId);

  return (
    <Sidebar>
      <ActionHeader
        title={t('updateFields')}
        icon={IconAttributeJourney}
        iconColor="elementPurpleInvert"
        {...props}
      />
      <Sidebar.Content>
        <UpdateFieldsFormContent
          action={data}
          journeyId={data.journey}
          filePath={filePath}
          onCancel={hideSidebar}
          onSubmit={(data) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: 'update_fields',
              values: { fields: data.fields },
              description: data.description,
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    updateFields: 'Update journey fields',
  },
};
